module.exports = __webpack_public_path__ + "static/media/icon_duopingtai.eb0b7998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_duopingtai.svg
// module id = 131
// module chunks = 0